import React from 'react'
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, getDemoMode } from 'store/storeValtio';
import { clearData } from 'helpers/storageHelpers';
import HelpTitle from 'components/common/HelpTitle';

export default function ClearData() {
  console.log('Clear Data');
  const navigate = useNavigate();

  function doClear() {
    clearData();
    window.location.href = '/';
  }

  function goToStart() {
    //window.location.href = '/index.js';
    navigate('/');
  }
  
  return (
    <div className='pt-8 h-full flex flex-col justify-normal items-center bg-blue-200 '>
      <HelpTitle title="Clear Data" helpSubject="ClearData" />
      <div className='w-8/12 flex flex-col justify-center item-center mt-10 text-2xl'>
        <div className='flex flex-col justify-center mt-10'>
            <button 
                onClick={()=>doClear()}
                className='rawBtn p-4 border-2 border-black bg-red-800' >
                Clear Data
            </button>
            <button 
                onClick={()=>goToStart()}
                className='rawBtn p-4 mt-6 border-2 border-black bg-red-300' >
                Cancel
            </button>
        </div>
      </div>
    </div>
  );

}
